import { createRouter, createWebHistory } from 'vue-router'
import { auth } from './firebase'
import LoginPage from './components/LoginPage.vue'
import DeviceCheckout from './components/DeviceCheckout.vue'
import DevicePreview from './components/DevicePreview.vue'
import MainPage from './components/MainPage.vue'
import UserProfile from './components/UserProfile.vue'
import CreateDevice from './components/CreateDevice.vue'
import UserManagement from './components/UserManagement.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/',
    name: 'MainPage',
    component: MainPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/device-checkout/:deviceId',
    name: 'DeviceCheckout',
    component: DeviceCheckout
  },
  {
    path: '/preview/:deviceId',
    name: 'DevicePreview',
    component: DevicePreview,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'UserProfile',
    component: UserProfile,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-device',
    name: 'CreateDevice',
    component: CreateDevice,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (!to.meta.requiresAuth) {
    next()
    return
  }

  const unsubscribe = auth.onAuthStateChanged((user) => {
    unsubscribe()
    if (user && user.email.endsWith('@nordeus.com')) {
      next()
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  })
})

export default router
